import React, { useEffect, useState } from 'react';
import EditIcon from '../../../../assets/svg/edit.svg';
import { ACL, UserCan } from '../../../../shared/constants';
import { getPersonAllowedSee } from '../../../../shared/db/general-db';
import {
  iItemsAllowed,
  iVisibleDevicesTags,
  MenuPinType
} from '../../../../shared/interfaces';
import LocalPersonTile from '../LocalPeopleTile';
import { Link } from 'react-router-dom';
import styles from '../PersonTabPage.module.scss';

import DevicesIcon from '../../../../assets/svg/devices.svg';
import PerfectScrollbar from "react-perfect-scrollbar";
import {compareStringsAlphabetically} from "../../../../shared/helpers";

export const VisibleDevicesTile = (props: iVisibleDevicesTags) => {
  const [allowed, setAllowed] = useState<iItemsAllowed>();
  const { userCanDo, personId, devicesDetails, editUrl, isPinned, showPin, tags } = props;
  const [collapsed, setCollapsed] = useState<boolean>(isPinned);
  const [visibleDevices, setVisibleDevices] = useState<any>([]);
  const [hoveredDeviceId, setHoveredDeviceId] = useState<string | null>(null);

  const devicesIds = devicesDetails.keySeq();

  useEffect(() => {
    setCollapsed(isPinned);
  }, [isPinned]);

  useEffect(() => {
    const getAllowedItems = async () => {
      const data = await getPersonAllowedSee(props.personId);

      setAllowed(data);
    }

    getAllowedItems();
  }, []);

  useEffect(() => {
    if (allowed) {
      const newVisibleDevices = Object.keys(allowed.device || {})
        .filter((deviceId) => devicesIds.includes(deviceId))
        .map((deviceId) => devicesDetails.get(deviceId)!);

      const sortedDevices = newVisibleDevices.sort((a, b) => {
        const nameA = a.name;
        const nameB = b.name;

        return compareStringsAlphabetically(nameA, nameB);
      })

      setVisibleDevices(sortedDevices);
    }
  }, [allowed]);

  const getSource = (deviceId): {
    id?: string,
    tags?: string[],
    device?: boolean,
    msg: string
  } => {
    if (allowed && allowed.device) {
      const source = Object.entries(allowed.device[deviceId]).filter(source => typeof(source[1]) !== 'boolean');

      const tagSources = source.map(source => {
        if (source[1] === 'tag') return tags[source[0]].details.name
      });
      const isDeviceSource = source.filter(source => source[1] === 'device').length > 0;

      const sources = [];
      if (isDeviceSource) sources.push('device');
      if (tagSources.length > 0) sources.push('tags');

      return {
        id: deviceId,
        tags: tagSources,
        device: isDeviceSource,
        msg: sources.join(' & ')
      }
    }

    return {
      msg: ''
    }
  }

  const hideTable = allowed?.device && Object.keys(allowed.device).length === 0;

  return (
    <LocalPersonTile
      collapsible
      initialCollapsed={collapsed}
      title='Visible Vehicles'
      loading={!allowed}
      action={
        !editUrl || !ACL.check(UserCan.DO_ANYTHING, userCanDo) ? undefined : (
          <Link to={editUrl}>
            <img src={EditIcon} alt='editIcon' className={styles.editIconStyle}/>
          </Link>
        )
      }
      isPinned={isPinned}
      withPin={false}
      property={MenuPinType.VISIBLE_DEVICES}
      leftIcon={null}
    >
      {(!visibleDevices || !allowed || hideTable) ? null : (
        <div className={styles.VisibleDevicesTileTableContainer}>
          <PerfectScrollbar>
            <div className={styles.TableWrapper}>
              <table className={styles.VisibleDevicesTileTable}>
                <thead>
                <tr className={styles.VisibleDevicesTileHeaderRow}>
                  <th style={{width:'90px'}}>Vehicle</th>
                  <th style={{width:'100%'}}>Tag</th>
                  {/*<th>Read Only</th>*/}
                </tr>
                </thead>
                <tbody>
                {visibleDevices.map((device) => {
                  // const isReadOnly = pathOr(false, ['device', device!.id, device!.id])(allowed);
                  const source = getSource(device!.id);
                  const filteredTagsSource = source.tags ? source.tags.filter(tagName => tagName && tagName.length > 0) : [];

                  return (
                    <tr key={device!.id} className={styles.VisibleDevicesTileTableRow}>
                      <td style={{width:'90px'}}>
                        {device!.name}
                      </td>
                      <td style={{width:'100%'}}
                      >
                       {filteredTagsSource.join(', ')}
                      </td>
                      {/*<td>*/}
                      {/*  {isReadOnly ? <CheckIcon style={{width: '16px', height: '16px'}}/> :*/}
                      {/*    <CloseIcon style={{width: '14px', height: '14px'}}/>}*/}
                      {/*</td>*/}
                    </tr>
                  )
                  })}
                </tbody>
              </table>
            </div>
          </PerfectScrollbar>
        </div>
      )}
    </LocalPersonTile>
  )
}
